module.exports = __webpack_public_path__ + "img/left_1.7a5476ee.jpg";